import { createContext, ReactNode } from "react";

export type OnboardingFlowStepType = "tooltip";

export type OnboardingFlowStep = {
  type: OnboardingFlowStepType;
  title?: string;
  text: string | ReactNode;
  onNext?: () => void;
};

export type OnboardingFlowId =
  | "postPurchase"
  | "planUpgraded"
  | "planDowngraded";

export interface OnboardingFlowsContextValue {
  activeFlow: OnboardingFlowId | null;
  activeStep: number;
  runFlow: (flowId: OnboardingFlowId) => void;
  nextStep: () => void;
  dismissFlow: () => void;
  isStepActive: (flowId: OnboardingFlowId, step: number) => boolean;
  getStep: (
    flowId: OnboardingFlowId,
    step: number
  ) => OnboardingFlowStep | undefined;
  getTotalSteps: (flowId: OnboardingFlowId) => number;
}

export const OnboardingFlowsContext =
  createContext<OnboardingFlowsContextValue | null>(null);
